import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ArrowRight, Scale, Gavel, Shield, FileText, Briefcase, Building2 } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Attorney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const practices = ["Diritto Societario", "Contenzioso Civile", "Responsabilità 231", "Diritto Immobiliare", "Diritto Bancario", "Arbitrati Nazionali", "Tutela Patrimoniale"];
  return;
}